<div class="uni-cell__label-container">
    <uni-text-header [weight]="isActive? uniTextWeight.medium: uniTextWeight.regular" [isUppercase]="false">
        <ng-content></ng-content>
    </uni-text-header>
</div>
